<div class="admin-shell">
    <header class="admin-header">
        <nav class="admin-tabs" aria-label="Admin sections">
            <a role="link" tabindex="0" [class.active]="IsActive('admin-dashboard')" (click)="GoTo('admin-dashboard')" (keydown.enter)="GoTo('admin-dashboard')">Dashboard</a>
            <a role="link" tabindex="0" [class.active]="IsActive('admin-configuration')" (click)="GoTo('admin-configuration')" (keydown.enter)="GoTo('admin-configuration')">Configuration</a>
            <a role="link" tabindex="0" [class.active]="IsActive('admin-partners')" (click)="GoTo('admin-partners')" (keydown.enter)="GoTo('admin-partners')">Partner Links</a>
        </nav>
        <h1>Partner Usage</h1>
        <p>Aggregate activity across all partner companies. Read-only.</p>
    </header>

    <p *ngIf="isLoading" class="status">Loading…</p>
    <p *ngIf="errorMessage" class="status error" role="alert">{{ errorMessage }}</p>

    <section *ngIf="!isLoading && !errorMessage">
        <p *ngIf="rows.length === 0" class="empty">No partner companies yet.</p>

        <table *ngIf="rows.length > 0" class="admin-table">
            <thead>
                <tr>
                    <th (click)="SetSort('companyName')">Company{{ SortIndicator('companyName') }}</th>
                    <th class="num" (click)="SetSort('activeTokenCount')">Tokens{{ SortIndicator('activeTokenCount') }}</th>
                    <th class="num" (click)="SetSort('totalSearches')">Total Searches{{ SortIndicator('totalSearches') }}</th>
                    <th class="num" (click)="SetSort('searches30d')">Searches (30d){{ SortIndicator('searches30d') }}</th>
                    <th class="num" (click)="SetSort('avgLatencyMs')">Avg Latency{{ SortIndicator('avgLatencyMs') }}</th>
                    <th class="num" (click)="SetSort('aiCost30d')">AI Cost (30d){{ SortIndicator('aiCost30d') }}</th>
                    <th class="num" (click)="SetSort('exports30d')">Exports (30d){{ SortIndicator('exports30d') }}</th>
                    <th (click)="SetSort('lastSearchAt')">Last Search{{ SortIndicator('lastSearchAt') }}</th>
                    <th>Soft Cap</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let r of sortedRows">
                    <td>{{ r.companyName }}</td>
                    <td class="num">{{ r.activeTokenCount }}</td>
                    <td class="num">{{ r.totalSearches }}</td>
                    <td class="num">{{ r.searches30d }}</td>
                    <td class="num">{{ r.avgLatencyMs != null ? (r.avgLatencyMs | number: '1.0-0') + ' ms' : '—' }}</td>
                    <td class="num">{{ r.aiCost30d | currency: 'USD' : 'symbol' : '1.2-4' }}</td>
                    <td class="num">{{ r.exports30d }}</td>
                    <td>{{ r.lastSearchAt ? (r.lastSearchAt | date: 'medium') : '—' }}</td>
                    <td>
                        <span *ngIf="r.anySoftCapExceeded" class="cap-flag" title="A token for this company exceeded its monthly soft cap">⚠ Exceeded</span>
                        <span *ngIf="!r.anySoftCapExceeded" class="cap-ok">—</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </section>

    <maps-email-activity></maps-email-activity>
</div>
